/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://jz7f3kuu0a.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        },
        {
            "name": "api85b3bd57Payment",
            "endpoint": "https://ua13p3pp60.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://tsf3rj4elfcohjruskvciszqxy.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-2ydvuyhhzfbtnlvckn2x7ibx7y",
    "aws_cognito_identity_pool_id": "us-east-1:7f8a58d0-bc88-4a89-9c6a-5a12689372de",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_FSaw0JA7K",
    "aws_user_pools_web_client_id": "4ldjddvdnvbmi2as5mo85au4h9",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "virtualsafeevents-20230119163746-hostingbucket-prod",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://dsiot4hcj3y9c.cloudfront.net",
    "aws_user_files_s3_bucket": "virtualsafeevents7a85beac93234fb79f888c563e70e2171532-prod",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
